/**
 * Rebuy inside the Horizon native cart drawer:
 * - Widget 229855 (recommendations)
 * - Announcements + shipping/gift tiers from Rebuy user config
 */
(function () {
  var WIDGET_ID = '229855';
  var CONFIG_URL = 'https://cached.rebuyengine.com/api/v1/user/config';
  var timer = null;
  var readyBound = false;
  var configPromise = null;
  // Last incentives markup rendered, so it can be put back the moment a cart re-render drops it.
  var lastIncentivesHtml = '';

  function runWidget() {
    if (!window.Rebuy) return;

    if (typeof window.Rebuy.init === 'function') {
      try {
        window.Rebuy.init();
      } catch (err) {
        console.warn('[rebuy-cart-trigger] Rebuy.init failed', err);
      }
    }

    var widgets = window.Rebuy.widgets;
    if (!Array.isArray(widgets)) return;

    var widget = widgets.find(function (item) {
      return String(item.id) === WIDGET_ID;
    });

    if (!widget || typeof widget.getWidgetProducts !== 'function') return;

    try {
      widget.getWidgetProducts();
    } catch (err) {
      console.warn('[rebuy-cart-trigger] getWidgetProducts failed', err);
    }
  }

  function getMount() {
    var drawer = document.querySelector('theme-drawer#cart-drawer');
    if (!drawer) return null;

    var mount = drawer.querySelector('[data-rebuy-incentives]');
    if (mount) return mount;

    var content = drawer.querySelector('.cart-drawer__content');
    if (!content) return null;

    mount = document.createElement('div');
    mount.className = 'cart-drawer__rebuy-incentives';
    mount.setAttribute('data-rebuy-incentives', '');

    var items = content.querySelector('.cart-drawer__items');
    if (items && items.parentNode) {
      items.parentNode.insertBefore(mount, items);
    } else {
      content.insertBefore(mount, content.firstChild);
    }

    return mount;
  }

  function getShopDomain() {
    if (window.Shopify && Shopify.shop) return Shopify.shop;
    return 'apollo-optics.myshopify.com';
  }

  function getSmartCartSettings() {
    if (window.Rebuy && Rebuy.SmartCart && Rebuy.SmartCart.settings) {
      return Rebuy.SmartCart.settings;
    }
    return null;
  }

  function loadConfig() {
    if (configPromise) return configPromise;

    var live = getSmartCartSettings();
    if (live && Array.isArray(live.components) && live.components.length) {
      configPromise = Promise.resolve(live);
      return configPromise;
    }

    configPromise = fetch(CONFIG_URL + '?shop=' + encodeURIComponent(getShopDomain()), {
      credentials: 'omit',
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Rebuy config ' + response.status);
        return response.json();
      })
      .then(function (json) {
        return (json && json.data && json.data.smart_cart) || {};
      })
      .catch(function (err) {
        console.warn('[rebuy-cart-trigger] config fetch failed', err);
        configPromise = null;
        return getSmartCartSettings() || {};
      });

    return configPromise;
  }

  function getComponents(settings, type) {
    var components = (settings && settings.components) || [];
    return components.filter(function (item) {
      return item && item.type === type && item.visibility_status !== 'hidden';
    });
  }

  function getAnnouncementMessages(settings) {
    var messages = [];
    getComponents(settings, 'announcement_bar').forEach(function (component) {
      var list = component.settings && component.settings.messages;
      if (!Array.isArray(list)) return;
      list.forEach(function (message) {
        if (message && String(message).trim()) messages.push(String(message).trim());
      });
    });
    return messages;
  }

  function getProgressBars(settings) {
    var bars = [];
    getComponents(settings, 'tiered_progress_bar').forEach(function (component) {
      var list = component.settings && component.settings.bars;
      if (!Array.isArray(list)) return;
      list.forEach(function (bar) {
        if (bar && Array.isArray(bar.tiers) && bar.tiers.length) bars.push(bar);
      });
    });
    return bars;
  }

  function loadCartSubtotalCents() {
    // Always re-fetch Shopify cart. Rebuy.Cart can lag behind Horizon updates,
    // and the Rebuy config URL is correctly cached (tiers don't change per cart).
    return fetch('/cart.js?ts=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        return Number(cart && cart.total_price) || 0;
      })
      .catch(function () {
        if (window.Rebuy && Rebuy.Cart && Rebuy.Cart.cart) {
          return Number(Rebuy.Cart.cart.total_price) || 0;
        }
        return 0;
      });
  }

  function tierMinimumCents(tier) {
    var minimum = Number(tier && tier.minimum);
    if (!minimum) return 0;
    // User config stores unlock prices in dollars (e.g. 249, 1500).
    return Math.round(minimum * 100);
  }

  function formatMoney(cents) {
    var smartCart = window.Rebuy && Rebuy.SmartCart;
    if (smartCart && typeof smartCart.formatMoney === 'function') {
      try {
        return smartCart.formatMoney(cents);
      } catch (err) {
        /* fall through */
      }
    }

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: 'USD',
      }).format((Number(cents) || 0) / 100);
    } catch (err) {
      return '$' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  function interpolate(template, values) {
    if (!template) return '';
    return String(template).replace(/\{\{\s*([a-z_]+)\s*\}\}/g, function (_, key) {
      return values[key] != null ? String(values[key]) : '';
    });
  }

  function getTierLabel(tier) {
    if (tier.custom_tier_label && tier.custom_tier_label_text) return tier.custom_tier_label_text;
    if (tier.type === 'shipping') return 'Free shipping';
    if (tier.type === 'product') return 'Free gift';
    if (tier.type === 'discount') return 'Discount';
    return 'Reward';
  }

  function getProgressMessage(bar, tiers, subtotalCents) {
    var language = (bar && bar.language) || {};
    var next = null;

    for (var i = 0; i < tiers.length; i++) {
      if (subtotalCents < tierMinimumCents(tiers[i])) {
        next = tiers[i];
        break;
      }
    }

    if (!next) {
      var last = tiers[tiers.length - 1];
      if (last && last.type === 'shipping') {
        return language.free_shipping_reached || 'You unlocked free shipping!';
      }
      if (last && last.product_amount_reached_label_text) {
        return interpolate(last.product_amount_reached_label_text, {
          product_title: 'gift',
        });
      }
      return language.free_shipping_reached || 'You unlocked the next reward!';
    }

    var remaining = formatMoney(tierMinimumCents(next) - subtotalCents);
    if (next.type === 'shipping') {
      return interpolate(
        language.free_shipping_remaining || 'You are {{remaining_amount}} away from FREE SHIPPING!',
        { remaining_amount: remaining }
      );
    }
    if (next.product_amount_remaining_label_text) {
      return interpolate(next.product_amount_remaining_label_text, {
        remaining_amount: remaining,
        product_title: 'gift',
      });
    }
    return interpolate('You are {{remaining_amount}} away from the next reward', {
      remaining_amount: remaining,
    });
  }

  function getPercent(tiers, subtotalCents) {
    var last = tiers[tiers.length - 1];
    var max = tierMinimumCents(last);
    if (!max) return 0;
    return Math.max(0, Math.min(100, (subtotalCents / max) * 100));
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderIncentives(settings, subtotalCents) {
    var mount = getMount();
    if (!mount) return;

    var announcements = getAnnouncementMessages(settings);
    var bars = getProgressBars(settings);

    if (!announcements.length && !bars.length) {
      mount.innerHTML = '';
      lastIncentivesHtml = '';
      return;
    }

    var html = '';

    announcements.forEach(function (message) {
      html +=
        '<div class="rebuy-incentives__announcement" data-rebuy-component="announcement-bar">' +
        escapeHtml(message) +
        '</div>';
    });

    bars.forEach(function (bar) {
      var tiers = bar.tiers;
      var message = getProgressMessage(bar, tiers, subtotalCents);
      var percent = getPercent(tiers, subtotalCents);

      html += '<div class="rebuy-incentives__progress" data-rebuy-component="progress-bar">';
      if (message) {
        html += '<p class="rebuy-incentives__progress-message">' + message + '</p>';
      }

      html += '<div class="rebuy-incentives__steps">';
      tiers.forEach(function (tier) {
        var complete = subtotalCents >= tierMinimumCents(tier);
        html +=
          '<span class="rebuy-incentives__step' +
          (complete ? ' is-complete' : '') +
          '">' +
          escapeHtml(getTierLabel(tier)) +
          '</span>';
      });
      html += '</div>';

      html +=
        '<div class="rebuy-incentives__meter" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' +
        Math.round(percent) +
        '">' +
        '<div class="rebuy-incentives__meter-fill" style="width:' +
        percent +
        '%"></div></div></div>';
    });

    if (mount.innerHTML !== html) mount.innerHTML = html;
    lastIncentivesHtml = html;
  }

  /**
   * The mount isn't part of the cart drawer's section HTML, so every cart re-render (add,
   * quantity change, remove) dropped the bar until the next refresh() ~350ms+ later — the
   * cart lines jumped up by the bar's height and back down again. Re-insert the last markup
   * as soon as it goes missing; observer callbacks run before paint, so it never visibly
   * disappears. refresh() then updates the amounts in place.
   */
  function keepIncentivesMounted() {
    var drawer = document.querySelector('theme-drawer#cart-drawer');
    if (!drawer || typeof MutationObserver === 'undefined') return;

    new MutationObserver(function () {
      if (!lastIncentivesHtml || drawer.querySelector('[data-rebuy-incentives]')) return;
      var mount = getMount();
      if (mount && !mount.innerHTML) mount.innerHTML = lastIncentivesHtml;
    }).observe(drawer, { childList: true, subtree: true });
  }

  function syncCheckoutButtonsHeight() {
    var drawer = document.querySelector('theme-drawer#cart-drawer');
    if (!drawer) return;

    var buttons = drawer.querySelector('div.additional-checkout-buttons');
    var rebuy = drawer.querySelector('[data-rebuy-id="229855"]');
    if (!buttons || !rebuy) return;

    buttons.style.height = '';

    var buttonsHeight = buttons.getBoundingClientRect().height;
    var rebuyHeight = rebuy.getBoundingClientRect().height;
    var nextHeight = buttonsHeight - rebuyHeight;
    if (nextHeight < 0) nextHeight = 0;

    buttons.style.height = nextHeight + 'px';
  }

  function refresh() {
    runWidget();
    Promise.all([loadConfig(), loadCartSubtotalCents()]).then(function (results) {
      renderIncentives(results[0], results[1]);
      syncCheckoutButtonsHeight();
    });
    syncCheckoutButtonsHeight();
  }

  function scheduleRender(delay) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      timer = null;
      refresh();
    }, typeof delay === 'number' ? delay : 250);
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;
      if (!target.closest('[data-testid="cart-drawer-trigger"], [aria-controls="cart-drawer"]')) {
        return;
      }
      scheduleRender(300);
    },
    true
  );

  document.addEventListener('theme-drawer:open', function (event) {
    var target = event.target;
    if (!(target instanceof Element) || target.id !== 'cart-drawer') return;
    scheduleRender(200);
  });

  document.addEventListener('rebuy.loaded', function () {
    scheduleRender(150);
  });
  document.addEventListener('rebuy:cart.ready', function () {
    scheduleRender(150);
  });
  document.addEventListener('rebuy:cart.change', function () {
    scheduleRender(200);
  });
  document.addEventListener('rebuy:smartcart.ready', function () {
    scheduleRender(150);
  });

  if (!readyBound) {
    readyBound = true;
    import('@shopify/events')
      .then(function (mod) {
        var name = mod.StandardEvents && mod.StandardEvents.cartLinesUpdate;
        if (!name) return;
        document.addEventListener(name, function (event) {
          if (event && event.promise && typeof event.promise.then === 'function') {
            event.promise
              .then(function () {
                scheduleRender(350);
              })
              .catch(function () {
                scheduleRender(350);
              });
            return;
          }
          scheduleRender(350);
        });
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      keepIncentivesMounted();
      scheduleRender(400);
    });
  } else {
    keepIncentivesMounted();
    scheduleRender(400);
  }
})();
